import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import campaignApi from 'services/api/campaign'

import styles from './AddCreditsDialog.module.scss'

const AddCreditsDialog = ({ currentCredits, onClose, onSuccess }) => {
  const { addToast } = useToasts()
  const [additionalCredits, setAdditionalCredits] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const additionalCreditsNumber = parseInt(additionalCredits, 10) || 0
  const totalCredits = (currentCredits || 0) + additionalCreditsNumber

  const handleSubmit = async () => {
    if (additionalCreditsNumber <= 0) {
      addToast('Please enter a valid number of credits to add.', {
        appearance: 'error',
        autoDismiss: true
      })
      return
    }

    setIsLoading(true)

    try {
      await campaignApi.addCampaignCredit({ credit: additionalCreditsNumber })
      addToast(`Successfully added ${additionalCreditsNumber} credits.`, {
        appearance: 'success',
        autoDismiss: true
      })
      onSuccess()
      onClose()
    } catch (error) {
      addToast(`Failed to add credits: ${error}`, {
        appearance: 'error',
        autoDismiss: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <ConfirmationDialog
      title="Add Campaign Credits"
      positiveMessage={isLoading ? 'Adding credits...' : 'Add credits'}
      negativeMessage="Cancel"
      onConfirm={handleSubmit}
      onClose={onClose}
      onReject={onClose}
      actLikeForm={true}
      isButtonDisabled={isLoading || additionalCreditsNumber <= 0}
      theme="blacklist"
    >
      <div className={styles.container}>
        <div className={styles.currentCredits}>
          <span className={styles.label}>Current credits:</span>
          <span className={styles.value}>{currentCredits || 0}</span>
        </div>

        <div className={styles.inputContainer}>
          <TextInput
            label="Additional credits to add"
            type="number"
            min="1"
            style={{ width: '100%' }}
            value={additionalCredits}
            onChangeValue={setAdditionalCredits}
            disabled={isLoading}
            placeholder="Enter credits"
          />
        </div>

        <div className={styles.totalCredits}>
          <span className={styles.label}>The hotel will have:</span>
          <span className={styles.totalValue}>{totalCredits} credits</span>
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default AddCreditsDialog
